export default {
  actionTypes: {
    loginUser: 'AUTH_LOGIN_USER',
    logoutUser: 'AUTH_LOGOUT_USER',
    getUserInfo: 'AUTH_GET_USER',
    clearAuthInfo: 'AUTH_CLEAR_USER_AUTHORIZATION',
    setAuthInfo: 'AUTH_SET_USER_AUTHORIZATION',
  },
  mutationTypes: {
    setUserLoading: 'AUTH_SET_LOADING',
    setIsAuthorized: 'AUTH_SET_IS_AUTHORIZED',
    setUserInfo: 'AUTH_SET_USER_INFO',
  },
  getterTypes: {
    userNameFirstLetter: 'userNameFirstLetter',
    mainRole: 'getMainRole',
  },
};
